import Cookies from 'js-cookie';
import config from '../config/config';
import {
  ACNT_ADMIN_ROLE,
  ACNT_ASSOCIATE_ROLE,
  ACNT_FINANCE_ROLE,
  ACNT_REVIEWER_ROLE,
  ACNT_SUPPORT_TIER_1,
  ACNT_SUPPORT_TIER_2,
  ADMIN_HOME_PAGE,
  ASSOCIATE_HOME_PAGE,
  CURRENCY_REGEX_WITH_TWO_OR_MORE_DECIMAL_PLACES,
  REVIEWER_HOME_PAGE,
} from '../constants';
import { getEnv } from '../config/axiosConfig';

export const homePageRedirection = (role, navigate, url) => {
  role?.includes(ACNT_ADMIN_ROLE) && navigate(ADMIN_HOME_PAGE);
  role?.includes(ACNT_REVIEWER_ROLE) && navigate(REVIEWER_HOME_PAGE);
  (role?.includes(ACNT_ASSOCIATE_ROLE) ||
    role?.includes(ACNT_FINANCE_ROLE) ||
    role?.includes(ACNT_SUPPORT_TIER_1) ||
    role?.includes(ACNT_SUPPORT_TIER_2)) &&
    navigate(ASSOCIATE_HOME_PAGE);
  const isLocalhost = url.includes('localhost');
  isLocalhost && navigate(ASSOCIATE_HOME_PAGE);
};

export const getVerifiedRole = (role, url) => {
  const authToken = Cookies.get('token');
  const roles = Cookies.get('userRole');
  const isLocalhostUrlOrHealth = url.includes('/health'); // || url.includes('localhost');
  if (isLocalhostUrlOrHealth) {
    return true;
  }
  if (!(authToken && roles)) {
    Cookies.set('redirectUrl-' + getEnv(config.cname), window.location.href, { domain: config.cname });
    window.location.href = config.ssoUrl;
    localStorage.removeItem('viewedFiles');
  } else {
    const rolePassingTheCondition = role?.filter((value) => authToken && roles?.includes(value));
    return rolePassingTheCondition.length > 0;
  }
};

export const getLoggedInUser = () => {
  const loggedUserFirstName = Cookies.get('firstName')
  const loggedUserLastName = Cookies.get('lastName')
  return loggedUserFirstName + " " + loggedUserLastName;
};

export const limitCurrencyToTwoDecimals = (value: string): string => {
  if (CURRENCY_REGEX_WITH_TWO_OR_MORE_DECIMAL_PLACES.test(value)) {
    const dotIndex = value.indexOf('.');
    value = value.slice(0, dotIndex + 3);
  }
  return value;
};

